


// import React, { useState } from "react";
// import React from 'react';
import {Link} from 'react-router-dom';
import "./loginmodal.css";
import AgendexLogo from '../../Assets/agendex/iconLogoAgendex.png'

function Login(){
    var ano = new Date().getFullYear();
    return <section id="loginmodal">
        <div className="container login-container">
            <div className="row">
                <div className="col-md-6 login-form-1">
                    <h3>Login Cliente</h3>
                        <form action="">
                            <div className="form-group">
                                <Link to="/app/login/cliente" style={{ textDecoration: 'none' }} type="button" className="btnSubmit" id="logincliente" name="logincliente" value="Login">Entrar</Link>
                            </div>
                            <div className="col-lg-6">

                            </div>
                            {/* <div className="form-group">
                                <Link to="/app/login/resetsenha" className="btnForgetPwd" value="Login">Esqueceu a senha?</Link>
                            </div> */}
                        </form>
                </div>
                <div className="col-md-6 login-form-2">
                    <div className="login-logo">
                        <img src={AgendexLogo} alt=""/>
                    </div>
                    <h3>Login Prestador</h3>
                    <form action="">
                        <div className="form-group">
                            <Link to="/app/login/prestador" style={{ textDecoration: 'none' }} type="button" className="btnSubmit" id="loginprestador" name="loginprestador" value="Login">Entrar</Link>
                        </div>
                        {/* <div className="form-group">
                            <Link to="/app/resetsenha" className="btnForgetPwd" value="Login">Esqueceu a senha?</Link>
                        </div> */}
                    </form>
                </div> 
            </div>
            <div className="form-group text-right">
                <Link to="/app/resetsenha" className="btnForgetPwd" value="Login">Esqueceu a senha?</Link>
            </div>
            <div className="textoRodape" >
                <Link to="/app/novaconta">Não tenho conta. Toque aqui para criar uma agora.</Link>
                <p > Desenvolvido por MVinfo Sistemas | WMX Group 2021 - {ano}</p>
            </div>
        </div>
    </section>
    }
    
    export default Login;
